import SAGrid, { GetDataResponse, GridGetDataProps, ISAGridRef } from 'components/Grid/SAGrid'
import { LegacyRef, useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { ICustomColumn, IDateSearchLocalStorageNames, IGridLocalStorageNames } from 'types'
import './HistoryGrid.css'
import moment from 'moment'
import { GridCellProps } from '@progress/kendo-react-grid'
import FormDateSpanSelector, { IFormDateSpanSelectorRef } from 'components/Form/FormDateSpanSelector'
import { Form, FormElement, FormHandle } from '@progress/kendo-react-form'
import { SortDescriptor } from '@progress/kendo-data-query'

interface IHistoryItem {
    historyId: number
    changes?: string | undefined
    changeMadeById: number | undefined
    changeMadeByName?: string | undefined
    createdDate: Date
}

interface IProps {
    identifierPropertyName?: string
    type: 'Case' | 'Dealer'
    historyData?: IHistoryItem[]
    getHistoryData?: (props: GridGetDataProps) => Promise<GetDataResponse>,
    historyGridRef: LegacyRef<ISAGridRef> | undefined
    dateSpanRef: LegacyRef<IFormDateSpanSelectorRef> | undefined
    historyDateSpanFormRef: LegacyRef<FormHandle> | undefined
    searchByDate: (startDate: Date, endDate: Date) => void
    maxDate: Date | undefined
}

const LOCAL_STORAGE_KEYS = {
    CASES: {
        RELATIVE_DATE_OPTION: 'caseHistoryRelativeDateOption',
        END_DATE: 'caseHistoryEndDate',
        START_DATE: 'caseHistoryStartDate',
        SORT: 'caseHistorySort',
        SEARCH: 'caseHistorySearch',
        PAGE_SIZE: 'caseHistoryPageSize',
        SELECTED_PAGE: 'caseHistorySelectedPage'
    },
    DEALERS: {
        RELATIVE_DATE_OPTION: 'dealerHistoryRelativeDateOption',
        END_DATE: 'dealerHistoryEndDate',
        START_DATE: 'dealerHistoryStartDate',
        SORT: 'dealerHistorySort',
        SEARCH: 'dealerHistorySearch',
        PAGE_SIZE: 'dealerHistoryPageSize',
        SELECTED_PAGE: 'dealerHistorySelectedPage'
    }
}


const HistoryGrid = ({ type, identifierPropertyName, getHistoryData, historyGridRef, dateSpanRef, searchByDate, maxDate, historyDateSpanFormRef }: IProps) => {

    const historyColumns: ICustomColumn[] = [
        { field: 'changes', title: 'Change' },
        { field: 'changeMadeByName', width: '185px', title: 'Change Made By' },
        { field: 'createdDate', width: '185px', title: 'Change Occurred', format: '{0:g}' },
    ]

    let dateSearchLocalStorageNames: IDateSearchLocalStorageNames = {
        startDate: type == 'Dealer' ? LOCAL_STORAGE_KEYS.DEALERS.START_DATE : LOCAL_STORAGE_KEYS.CASES.START_DATE,
        endDate: type == 'Dealer' ? LOCAL_STORAGE_KEYS.DEALERS.END_DATE : LOCAL_STORAGE_KEYS.CASES.END_DATE,
        relativeDateOption: type == 'Dealer' ? LOCAL_STORAGE_KEYS.DEALERS.RELATIVE_DATE_OPTION : LOCAL_STORAGE_KEYS.CASES.RELATIVE_DATE_OPTION,
    }
    let gridLocalStorageNames: IGridLocalStorageNames = {
        sort: type == 'Dealer' ? LOCAL_STORAGE_KEYS.DEALERS.SORT : LOCAL_STORAGE_KEYS.CASES.SORT,
        search: type == 'Dealer' ? LOCAL_STORAGE_KEYS.DEALERS.SEARCH : LOCAL_STORAGE_KEYS.CASES.SEARCH,
        selectedPage: type == 'Dealer' ? LOCAL_STORAGE_KEYS.DEALERS.SELECTED_PAGE : LOCAL_STORAGE_KEYS.CASES.SELECTED_PAGE,
        pageSize: type == 'Dealer' ? LOCAL_STORAGE_KEYS.DEALERS.PAGE_SIZE : LOCAL_STORAGE_KEYS.CASES.PAGE_SIZE,
    }

    return (
        <div className={type + '-history-grid'} id={type + 'HistoryGrid'}>
            <div className='bg-light shadow-sm p-3 border pb-5'>
                <Row>
                    <Col md={6}><h4>{type} History</h4></Col>
                    <Col md={6} className='text-start text-md-end' style={{ alignSelf: 'center' }}></Col>
                    <Form
                        ref={historyDateSpanFormRef}
                        ignoreModified={true}
                        render={(formRenderProps) => (
                            <FormElement>
                                <FormDateSpanSelector
                                    ref={dateSpanRef}
                                    className=''
                                    formRenderProps={formRenderProps}
                                    localStorageNames={dateSearchLocalStorageNames}
                                    onSearch={searchByDate}
                                    maxDate={maxDate}
                                />
                            </FormElement>
                        )}
                    />
                    <Col xs={12} className='pt-4'>
                        {gridLocalStorageNames &&
                            <SAGrid
                                identifierPropertyName={identifierPropertyName}
                                features={{ simpleSearch: true, pageable: true, sortable: true, }}
                                columns={historyColumns}
                                defaultSort={[{ field: 'createdDate', dir: 'desc' }]}
                                getData={getHistoryData}
                                ref={historyGridRef}
                                localStorageNames={gridLocalStorageNames}
                            />}
                    </Col>
                </Row>
            </div>
        </div>
    )
}
export default HistoryGrid

